import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'
import { renderInputField, renderSelectField } from '../utils/forms'

import { addFault } from '../actions/faults'

class RemoteActionFaultAddForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      actionCompleted: false,
      errorMessage: '',
      faultType: ''
    }

    this.submit = this.submit.bind(this)
    this.handleFaultTypeSelect = this.handleFaultTypeSelect.bind(this)
  }

  componentDidMount() {

  }

  handleFaultTypeSelect(faultType) {
    this.setState({ faultType })  // Set the selected BlockType in the state
  }

  submit = async (props) => {
    const { reset } = this.props;
    const { faultType } = this.state;

    if (faultType === '') {
      this.setState({ errorMessage: 'Por favor, selecciona un tipo de avería.' });
      throw new SubmissionError({ _error: 'Por favor, selecciona un tipo de avería.' });
    }

    this.setState({ loading: true, actionCompleted: false })

    //GENERAL

    props.Machine = this.props.machine._id
    props.Serial = this.props.machine.Serial
    props.Locker = this.props.lockerSN
    props.FaultCode = faultType;
    props.Status = 'PENDING'
    props.LockerType = this.props.lockerType

    try {
      const response = await this.props.addFault(props)

      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields
        })
      }

      this.setState({ loading: false, actionCompleted: true })

      // Trigger matrix data refresh
      if (this.props.refreshMatrixData) {
        this.props.refreshMatrixData();
      }
      reset();
      return response
    } catch (error) {
      this.setState({ loading: false, errorMessage: error.message || 'Error processing action' })
      throw error
    }
  }

  render() {
    const { error, pristine, submitting, handleSubmit } = this.props
    const { loading, actionCompleted, faultType } = this.state

    if (loading) {
      return (
        <div className="lm-state">
          <span className="lm-state-msg">Ejecutando avería...</span>
          <LoadingProgress logoHeight={36} className="compact" />
        </div>
      )
    }

    if (actionCompleted) {
      return (
        <div className="lm-alert-stack">
          <div className="lm-alert lm-alert-success">Avería registrada correctamente</div>
        </div>
      )
    }


    return (
      <div>
        <form onSubmit={handleSubmit(this.submit)}>
          <div className="lm-fault-grid">
            <button
              type="button"
              className={`lm-fault-btn ${this.state.faultType === 'BROKEN_LOCK' ? 'lm-fault-btn-selected' : ''}`}
              onClick={() => this.handleFaultTypeSelect('BROKEN_LOCK')}
            >
              <img src="/images/faults/lock_anchorage.png" alt="BROKEN_LOCK" />
              <p>PINCHO ROTO</p>
            </button>
            <button
              type="button"
              className={`lm-fault-btn ${this.state.faultType === 'PINPAD_BLOCK' ? 'lm-fault-btn-selected' : ''}`}
              onClick={() => this.handleFaultTypeSelect('PINPAD_BLOCK')}
            >
              <img src="/images/faults/lockpad_battery.png" alt="PINPAD_BLOCK" />
              <p>TECLADO APAGADO</p>
            </button>
            <button
              type="button"
              className={`lm-fault-btn ${this.state.faultType === 'DOOR_BLOCK' ? 'lm-fault-btn-selected' : ''}`}
              onClick={() => this.handleFaultTypeSelect('DOOR_BLOCK')}
            >
              <img src="/images/faults/lock_door.png" alt="DOOR_BLOCK" />
              <p>PUERTA NO CIERRA</p>
            </button>
            <button
              type="button"
              className={`lm-fault-btn ${this.state.faultType === 'PINPAD_ACTIVE' ? 'lm-fault-btn-selected' : ''}`}
              onClick={() => this.handleFaultTypeSelect('PINPAD_ACTIVE')}
            >
              <img src="/images/faults/lockpad_broken.png" alt="PINPAD_ACTIVE" />
              <p>TECLADO ENCENDIDO</p>
            </button>
            <button
              type="button"
              className={`lm-fault-btn ${this.state.faultType === 'RED_BLOCK' ? 'lm-fault-btn-selected' : ''}`}
              onClick={() => this.handleFaultTypeSelect('RED_BLOCK')}
            >
              <img src="/images/faults/red_lock.png" alt="RED_BLOCK" />
              <p>PIN ROJO, NO ABRE</p>
            </button>
            <button
              type="button"
              className={`lm-fault-btn ${this.state.faultType === 'GREEN_BLOCK' ? 'lm-fault-btn-selected' : ''}`}
              onClick={() => this.handleFaultTypeSelect('GREEN_BLOCK')}
            >
              <img src="/images/faults/green_lock.png" alt="GREEN_BLOCK" />
              <p>PIN VERDE, NO ABRE</p>
            </button>
          </div>

          <div className="lm-form-footer">
            <button className="lm-btn-cancel" type="button" onClick={this.props.closeMatrixDialog}>
              Cancelar
            </button>
            <button className="lm-btn-confirm" type="submit" disabled={submitting || faultType === ''}>
              <i className="fas fa-bolt"></i>
              Confirmar avería
            </button>
          </div>

          {error && <div className="lm-alert-stack">
            <div className="lm-alert lm-alert-danger">{error}</div>
          </div>}
        </form>
      </div>
    )
  }
}

RemoteActionFaultAddForm = reduxForm({
  form: 'RemoteActionFaultAddForm',
})(RemoteActionFaultAddForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  formValues: state.form.RemoteActionFaultAddForm && state.form.RemoteActionFaultAddForm.values,
})

const mapDispatchToProps = dispatch => ({
  addFault: bindActionCreators(addFault, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionFaultAddForm)
